import {
  SEARCH_COMPANIES_START,
  SEARCH_COMPANIES_SUCCESS,
  SEARCH_COMPANIES_ERROR,
  UPDATE_COMPANY_START,
  UPDATE_COMPANY_SUCCESS,
  UPDATE_COMPANY_ERROR,
  SET_COMPANY,
  GET_COMPANY_BY_ID_SUCCESS,
  GET_COMPANY_BY_ID_ERROR,
  SET_ADMIN_COMPANY,
  GET_ADMIN_COMPANY_BY_ID_SUCCESS,
  GET_ADMIN_COMPANY_BY_ID_ERROR,
  GET_COMPANIES_START,
  GET_COMPANIES_SUCCESS,
  GET_COMPANIES_CSV_SUCCESS,
  GET_COMPANIES_ERROR,
  CREATE_COMPANY_PAYMENT_SUCCESS,
  UPDATE_COMPANY_PAYMENT_SUCCESS
} from "../actions/company.actions";

const INITIAL_STATE = {
  companies: [],
  companies_csv: [],
  isLoading: false,
  company: {},
  adminCompany: {},
  loadingGetCompanies: false
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SEARCH_COMPANIES_START:
      return { ...state, isLoading: true };
    case SEARCH_COMPANIES_SUCCESS:
      return { ...state, companies: action.data, isLoading: false };
    case SEARCH_COMPANIES_ERROR:
      return { ...state, isLoading: false };
    case UPDATE_COMPANY_START:
      return { ...state };
    case UPDATE_COMPANY_SUCCESS:
      return { ...state };
    case UPDATE_COMPANY_ERROR:
      return { ...state };
    case SET_COMPANY:
      return { ...state, company: action.data };
    case GET_COMPANY_BY_ID_SUCCESS:
      return { ...state, company: action.data };
    case GET_COMPANY_BY_ID_ERROR:
      return { ...state, error: action.error };
    case SET_ADMIN_COMPANY:
      return { ...state, adminCompany: action.data };
    case GET_ADMIN_COMPANY_BY_ID_SUCCESS:
      return { ...state, adminCompany: action.data };
    case GET_ADMIN_COMPANY_BY_ID_ERROR:
      return { ...state, error: action.error };
    case GET_COMPANIES_START:
      return { ...state, loadingGetCompanies: true };
    case GET_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.companies,
        loadingGetCompanies: false
      };
    case GET_COMPANIES_CSV_SUCCESS:
      return {
        ...state,
        companies_csv: action.companies,
        loadingGetCompanies: false
      };
    case GET_COMPANIES_ERROR:
      return { ...state, loadingGetCompanies: false };
    case CREATE_COMPANY_PAYMENT_SUCCESS:
      return { ...state, adminCompany: action.data };
    case UPDATE_COMPANY_PAYMENT_SUCCESS:
      return { ...state, adminCompany: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company.reducer.js